import { render } from "./ExpandedRowFullCase.vue?vue&type=template&id=2aa2bc3a"
import script from "./ExpandedRowFullCase.vue?vue&type=script&lang=js"
export * from "./ExpandedRowFullCase.vue?vue&type=script&lang=js"

import exportComponent from "E:\\my project backsups\\vue\\vuestyle3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__